import { render, staticRenderFns } from "./tgosMap.vue?vue&type=template&id=867b7b64&scoped=true&"
import script from "./tgosMap.vue?vue&type=script&lang=js&"
export * from "./tgosMap.vue?vue&type=script&lang=js&"
import style0 from "./tgosMap.vue?vue&type=style&index=0&id=867b7b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b7b64",
  null
  
)

export default component.exports